import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ScrollPositionService} from '../../services/scroll-position.service';

declare var $: any;

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit, AfterViewInit {
  values = [
    {
      title: 'Be humble and encouraging',
      image: {
        url: 'assets/images/cv01.jpg',
        alt: 'Be humble and encouraging'
      }
    },
    {
      title: 'Create joy for others',
      image: {
        url: 'assets/images/cv02.jpg',
        alt: 'Create joy for others'
      }
    },
    {
      title: 'Create meaningful communication',
      image: {
        url: 'assets/images/cv03.jpg',
        alt: 'Create meaningful communication'
      }
    },
    {
      title: 'Be better',
      image: {
        url: 'assets/images/cv04.jpg',
        alt: 'Be better'
      }
    },
    {
      title: 'Build rapport',
      image: {
        url: 'assets/images/cv05.jpg',
        alt: 'Build rapport'
      }
    },
    {
      title: 'Build solutions, remove obstacles',
      image: {
        url: 'assets/images/cv06.jpg',
        alt: 'Build solutions, remove obstacles'
      }
    },
    {
      title: 'Pursue learning and growth',
      image: {
        url: 'assets/images/cv07.jpg',
        alt: 'Pursue learning and growth'
      }
    },
    {
      title: 'Embrace change and innovation',
      image: {
        url: 'assets/images/cv08.jpg',
        alt: 'Embrace change and innovation'
      }
    },
  ];

  constructor(private spService: ScrollPositionService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.spService.autoScroll();
    $('.values-texts').slick({
      fade: true,
      appendArrows: '.values-arrows',
      prevArrow: '<button type="button" class="slick-prev">&#8592;</button>',
      nextArrow: '<button type="button" class="slick-next">&#8594;</button>',
      asNavFor: '.values-images'
    });
    $('.values-images').slick({
      fade: true,
      arrows: false,
      asNavFor: '.values-texts',
    });
  }

  scrollPastHero() {
    this.spService.scrollPastHero();
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/team/team.component.ts